import type { FC } from "react";

import { CardGenericHeaderSection } from "@jti/ui/components/CardGeneric/CardGenericHeaderSection";

import type { genericLayoutTitleInputs } from "./GenericLayoutTitle.builder";

type GenericLayoutTitleBuilderProps = BuilderComponentProps<typeof genericLayoutTitleInputs>;

export const GenericLayoutTitle: FC<GenericLayoutTitleBuilderProps> = ({
  title,
  secondaryTitle,
  description,
  reverseOrder = false,
}) => {
  return (
    <CardGenericHeaderSection
      title={title}
      secondaryTitle={secondaryTitle}
      description={description}
      reverseOrder={reverseOrder}
    />
  );
};
